import en from "./en";
import fa from "./fa";

const supportedLanguages = ["en", "fa"];
const storedLanguage = localStorage.getItem("lang");

export const lang = supportedLanguages.includes(storedLanguage)
  ? storedLanguage
  : "en";

const translations = {
  en,
  fa,
};

export function getDirection() {
  return lang === "fa" ? "rtl" : "ltr";
}

export function getFont() {
  return lang === "fa"
    ? "IRANSans"
    : '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif';
}

export function getTranslate() {
  return translations[lang];
}

export function changeLanguage(newLanguage) {
  if (!supportedLanguages.includes(newLanguage) || newLanguage === lang) {
    return;
  }

  localStorage.setItem("lang", newLanguage);
  window.location.reload();
}
